import { AxiosResponse } from "axios";
import { INewPatientPayload, INewPatientResponse } from "~/types/patient";
import { egisApi } from "~/utils/api";

export const createPatientService = (
  payload: INewPatientPayload
): Promise<AxiosResponse<INewPatientResponse, typeof payload>> => {
  return egisApi.post<
    INewPatientResponse,
    AxiosResponse<INewPatientResponse, typeof payload>,
    typeof payload
  >(`/hospital/patient/create_with_check`, payload);
};
